<template>

  <div id="app">

    <el-container style="width: 100%;height: 100%">
      <el-header style="padding: 0" v-if='$route.query.isAllpage!=1'>
        <Header></Header>
      </el-header>
      <el-container style="height: 87%;">
        <el-aside width="200px" style="overflow: hidden;background-color: rgb(35, 38, 44);" class="bg" v-if='$route.query.isAllpage!=1'>
          <Nav class="nav"></Nav>
        </el-aside>
        <el-main class="bg" style="min-width: 540px" :style="$route.query.isAllpage!=1 ? '' :'padding:0px;'"  >
          <div class="content" :style="$route.query.isAllpage==1 ? 'height:100%' :''">
            　
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive" class="router-view">
              </router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive" class="router-view"></router-view>
          </div>
        </el-main>
      </el-container>
      <!--<div class="right-info" v-if='$route.query.isAllpage!=1'>-->
      <!--<div class="info-left" >-->
        <!--&lt;!&ndash;<i class="iconfont icon-guanbi close" ></i>&ndash;&gt;-->
        <!--<i class="iconfont icon-dianhua1" style="margin-right: 15px;font-size: 24px"></i>-->
        <!--<p style="line-height: 25px">{{$t('AllPage.Tel')}}<br><span style="color:#ff6a00 ">400-11888-01</span></p>-->
      <!--</div>-->
        <!--<p class="info-right"><i class="iconfont icon-lianxiwomen" style="margin-bottom: 10px"></i>{{$t('AllPage.Us')}}</p>-->
      <!--</div>-->
      <div class="footer"  v-if='$route.query.isAllpage!=1'  @click="goto" style="cursor: pointer">
       {{FooterFont}}
      </div>
    </el-container>

  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Nav from '@/components/Nav'

  export default {
    name: 'App',
    data() {
      return {
        transitionName: 'slide'
      }
    },
    components: {
      Header,
      Nav
    },
    methods:{
      goto(){
        window.location.href='https://beian.miit.gov.cn/ '
      },
    }
  }

</script>

<style>
  @import "common/common.css";
.right-info{
  z-index:999;
  box-shadow: 0 6px 12px 0 rgba(0,0,0,.15);
  background-color: white;
  position: fixed;
  right: 20px;
  bottom: 150px;
  display: flex;
  flex-direction: row;
  }
  .info-left{
    display: none;
    position: relative;
    color: #3b464f;
    padding: 15px;
    flex-direction: row;
    justify-items: center;
    align-items: center;
  }
  .info-left .close{
    position: absolute;right: 15px;top: 15px;cursor: pointer;color: #cfcfd1;

  }
  .info-left .close:hover{
    color: #ff6a00;
  }
  .info-right{
    color: #ff6a00;
    font-weight:600;
    writing-mode:tb-rl;
    box-shadow: 0px 0 8px 0 #ddd;
    padding: 15px
  }

  .right-info:hover .info-left{
    display: flex;
  }







  .footer{
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    background-color: #23262c;
    color: white;
    text-align: center;
  }
  .fade-enter-active {
    transition: opacity .5s;
  }

  .fade-leave-active {
    transition: opacity 0s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }


  .bg {
    background-color: #eaedf1;
  }

  #app {
    width: 100%;
    height: 100%;

  }


  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }


  .content {
    background-color: #eaedf1;
    width: 100%;
    /*height: 100%;*/
    float: right;
  }

  .nav {
    width: 210px;
    height: 100%;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue